import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { JSX } from "react";
import Layout from "./layout-components/Layout";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Product from "./pages/Product/Product";
import Package from "./pages/Package/Package";
import OrderList from "./pages/Order/OrderList";
import CreateOrder from "./pages/Order/CreateOrder";
import Booking from "./pages/Booking/BookingList";
import CreateBooking from "./pages/Booking/CreateBooking";
import Payment from "./pages/Payment/Payment";
import Staff from "./pages/Staff/Staff";
import StaffService from "./pages/Staff/StaffService";
import StaffPayment from "./pages/Staff/StaffPayment";
import Customer from "./pages/Customer/Customer";
import CustomerQuery from "./pages/Customer/CustomerQuery";
import Purchase from "./pages/Purchase/Purchase";
import BusinessInfo from "./pages/Business/BusinessInfo";
import DirectLogin from "./pages/DirectLogin";
import SampleList from "./pages/CodeExample/SampleList";
import SampleForm from "./pages/CodeExample/SampleForm";
import EditBusinessInfo from "./pages/Business/EditBusinessInfo";
import EditItem from "./pages/Service/EditItem";
import ServiceList from "./pages/Service/ServiceList";
import ServiceForm from "./pages/Service/ServiceForm";
import ViewItem from "./pages/Service/ViewItem";
import Categorization from "./pages/Categorization/Categorization";
import EditCategorization from "./pages/Categorization/EditCategorization";
import EditService from "./pages/Service/EditService";
import BookingList from "./pages/Booking/BookingList";

const isAuthenticated = () => !!localStorage.getItem("access_token");
// Protected + Layout wrapper
const ProtectedLayout = ({ children }: { children: JSX.Element }) =>
  isAuthenticated() ? <Layout>{children}</Layout> : <Navigate to="/login" />;

// Centralized protected routes
const routes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/profile", element: <Profile /> },
  { path: "/services", element: <ServiceList /> },
  { path: "/create-service", element: <ServiceForm /> },
  { path: "/edit-service/:id", element: <EditService /> },
  { path: "/products", element: <Product /> },
  { path: "/packages", element: <Package /> },
  { path: "/orders", element: <OrderList /> },
  { path: "/orders/new", element: <CreateOrder /> },
  { path: "/bookings", element: <BookingList /> },
  { path: "/bookings/new", element: <CreateBooking /> },
  { path: "/payments", element: <Payment /> },
  { path: "/staffs", element: <Staff /> },
  { path: "/staff-services", element: <StaffService /> },
  { path: "/staff-payments", element: <StaffPayment /> },
  { path: "/customers", element: <Customer /> },
  { path: "/customer-queries", element: <CustomerQuery /> },
  { path: "/purchase", element: <Purchase /> },
  { path: "/business-info", element: <BusinessInfo /> },
  { path: "/business-info-edit", element: <EditBusinessInfo /> },
  { path: "/edit-item", element: <EditItem /> },
  { path: "/view-item", element: <ViewItem /> },
  { path: "/categorization", element: <Categorization /> },
  { path: "/edit-categorization", element: <EditCategorization /> },
];

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route
          path="/login"
          element={!isAuthenticated() ? <Login /> : <Navigate to="/dashboard" />}
        />

        <Route path="/direct-login" element={<DirectLogin />} />

        {/* Default route */}
        <Route
          path="/"
          element={
            <ProtectedLayout>
              <Dashboard />
            </ProtectedLayout>
          }
        />

        {/* Auto-mapped protected routes */}
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<ProtectedLayout>{element}</ProtectedLayout>}
          />
        ))}

        {/* Not found */}
        <Route
          path="*"
          element={
            isAuthenticated() ? (
              <ProtectedLayout>
                <NotFound />
              </ProtectedLayout>
            ) : (
              <NotFound />
            )
          }
        />

        {/* example code for CRUD operations */}

        <Route path="/samples" element={<SampleList />} />
        <Route path="/samples/create" element={<SampleForm />} />
        <Route path="/samples/:id/edit" element={<SampleForm />} />
      </Routes>
    </Router>
  );
};

export default App;
